import { DesignDemoState } from './index';
import produce from 'immer';

export namespace handlers {
  export const handleCreateWeddingClick = () =>
    produce<DesignDemoState>(draft => {
      draft.showCreateWeddingModal = true;
    });

  export const handleCreateWeddingClose = () =>
    produce<DesignDemoState>(draft => {
      draft.showCreateWeddingModal = false;
    });
}
